/**
 * Запит відкрити «Налаштування подання» з подання (прототип v4: примітка «Приховано стовпців: N … · Виберіть стовпці в налаштуваннях подання»):
 * подання надсилає запит, сторінка таблиці (useViewSettings) відкриває панель для вибраного подання. Без стану — лише сповіщення підписників.
 */
const listeners = new Set<() => void>();

export const viewSettingsRequest = {
  request: (): void => listeners.forEach((l) => l()),
  subscribe: (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};
